const categoryKeys = ['spa', 'casa', 'patitas', 'paseo', 'ropita'];
const categoryFromHash = () => {
  const key = location.hash.replace('#pec-category-', '');
  return categoryKeys.includes(key) ? key : 'all';
};
function applyCategory() {
  const home = document.querySelector('[data-pec-home]');
  if (!home) return;
  const key = categoryFromHash();
  const guide = home.querySelector('[data-pec-fit-guide]');
  if (guide) guide.hidden = key !== 'ropita';
  const title = home.querySelector('[data-pec-catalog-title]');
  const intro = home.querySelector('[data-pec-catalog-intro]');
  const count = home.querySelector('[data-pec-catalog-count]');
  title.dataset.defaultText ||= title.textContent;
  intro.dataset.defaultText ||= intro.textContent;
  const category = home.querySelector('.pec-collection[data-pec-category="' + key + '"]');
  title.textContent = category ? category.querySelector('h3').textContent : title.dataset.defaultText;
  intro.textContent = category ? category.dataset.pecDescription : intro.dataset.defaultText;
  let visible = 0;
  home.querySelectorAll('.pec-card[data-pec-categories]').forEach(card => {
    const categories = card.dataset.pecCategories.split(/\s+/).map(tag => tag.replace('coleccion:', ''));
    card.hidden = key !== 'all' && !categories.includes(key);
    if (!card.hidden) visible++;
  });
  count.textContent = count.dataset.format.replace('[count]', String(visible));
  home.querySelectorAll('[data-pec-category]').forEach(link => {
    if (link.dataset.pecCategory === key) link.setAttribute('aria-current', 'true');
    else link.removeAttribute('aria-current');
  });
  const nav = home.querySelector('.pec-category-nav');
  const selected = nav.querySelector('[aria-current="true"]');
  if (selected) nav.scrollTo({ left: selected.offsetLeft - (nav.clientWidth - selected.clientWidth) / 2, behavior: 'instant' });
}
async function closeNavigation(link) {
  const cart = link.closest('theme-drawer');
  const panel = cart?.querySelector('dialog');
  if (panel?.open && typeof cart.close === 'function') {
    await new Promise(resolve => {
      panel.addEventListener('close', resolve, { once: true });
      cart.close();
    });
  }
  const menu = link.closest('header-drawer');
  if (menu?.isOpen && typeof menu.close === 'function') {
    await new Promise(resolve => {
      const details = menu.querySelector('details');
      const observer = new MutationObserver(() => {
        if (!details.hasAttribute('open')) {
          observer.disconnect();
          resolve();
        }
      });
      observer.observe(details, { attributes: true, attributeFilter: ['open'] });
      menu.close();
    });
  }
}
function revealTarget(hash, focus = false) {
  const category = hash.startsWith('#pec-category-');
  const target = document.querySelector(category ? '#pec-products' : hash);
  if (!target) return;
  if (target instanceof HTMLDetailsElement) target.open = true;
  target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  if (focus && (category || hash === '#pec-products')) {
    document.querySelector('[data-pec-catalog-title]')?.focus({ preventScroll: true });
  }
}
document.addEventListener('click', async event => {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest?.('a[href]');
  if (!link) return;
  const destination = new URL(link.href, location.href);
  if (!destination.hash.startsWith('#pec-')) return;
  const isHome = Boolean(document.querySelector('[data-pec-home]'));
  const samePage = destination.origin === location.origin && destination.pathname === location.pathname;
  if (!isHome || !samePage) {
    if (link.hasAttribute('data-pec-continue-shopping')) {
      event.preventDefault();
      await closeNavigation(link);
      location.assign(destination.href);
    }
    return;
  }
  event.preventDefault();
  await closeNavigation(link);
  if (location.hash !== destination.hash) history.pushState(null, '', destination.hash);
  applyCategory();
  revealTarget(destination.hash, true);
});
window.addEventListener('hashchange', () => { applyCategory(); revealTarget(location.hash); });
window.addEventListener('popstate', () => { applyCategory(); if (location.hash.startsWith('#pec-')) revealTarget(location.hash); });
window.addEventListener('pageshow', () => applyCategory());
document.addEventListener('shopify:section:load', () => applyCategory());
applyCategory();
if (location.hash.startsWith('#pec-category-')) requestAnimationFrame(() => revealTarget(location.hash));



function setupCloset(){
 const root=document.querySelector('[data-pec-closet-picker]'), native=document.querySelector('.pec-kit-native');if(!root||!native)return;
 const selects=[...root.querySelectorAll('select')];
 selects.forEach(sel=>{
 const pair=Number(sel.dataset.pecKitPair),part=Number(sel.dataset.pecKitPart);
 const inputs=[...native.querySelectorAll('input[type=radio]')].filter(x=>Number(x.dataset.fieldsetIndex)===pair);
 const selected=inputs.find(x=>x.checked)?.value.split(' / ')[part]||'';
 for(const opt of sel.options){if(!opt.value)continue;const available=inputs.some(x=>x.value.split(' / ')[part]===opt.value&&!x.disabled);opt.disabled=!available;const label=opt.value+(available?'':' — Agotado');if(opt.textContent!==label)opt.textContent=label;}
 sel.value=selected;sel.disabled=![...sel.options].some(o=>o.value&&!o.disabled);
 if(sel.dataset.ready)return;sel.dataset.ready='true';
 sel.addEventListener('change',()=>{
 const sibling=selects.find(s=>s!==sel&&s.dataset.pecKitPair===sel.dataset.pecKitPair);if(!sibling.value)return;
 const values=[];values[part]=sel.value;values[1-part]=sibling.value;
 const input=[...document.querySelectorAll('.pec-kit-native input[type=radio]')].find(x=>Number(x.dataset.fieldsetIndex)===pair&&x.value===values.join(' / '));
 if(input&&!input.disabled){input.click();}else{sel.value=[...document.querySelectorAll('.pec-kit-native input[type=radio]')].find(x=>Number(x.dataset.fieldsetIndex)===pair&&x.checked)?.value.split(' / ')[part]||'';root.querySelector('[role=status]').textContent='Esta combinación está agotada. Elige otro diseño disponible.';}
 });
 });
 const status=root.querySelector('[role=status]'),msg=selects.every(s=>s.disabled)?'Kit temporalmente agotado. Ningún diseño se cobrará sin disponibilidad.':'Elige un diseño disponible de cada prenda.';if(status.textContent!==msg)status.textContent=msg;
}
let closetFrame;new MutationObserver(()=>{cancelAnimationFrame(closetFrame);closetFrame=requestAnimationFrame(setupCloset)}).observe(document.documentElement,{childList:true,subtree:true});setupCloset();

function setupKitGalleries(){
 document.querySelectorAll('[data-pec-kit-gallery]').forEach(root=>{
  if(root.dataset.kitReady)return;root.dataset.kitReady='true';
  const select=root.querySelector('[data-kit-select]');
  function showGroup(value){root.querySelectorAll('[data-kit-panel]').forEach(panel=>{panel.hidden=panel.dataset.kitPanel!==value});root.querySelector('[data-kit-group="overview"]').setAttribute('aria-pressed',String(value==='overview'));select.value=value;}
  root.addEventListener('click',event=>{
   const group=event.target.closest('[data-kit-group]');if(group){showGroup(group.dataset.kitGroup);return;}
   const photo=event.target.closest('[data-kit-photo]');if(!photo)return;
   const panel=photo.closest('[data-kit-panel]'),main=panel.querySelector('[data-kit-main]');
   main.src=photo.dataset.kitPhoto;main.alt=photo.dataset.kitAlt;
   panel.querySelectorAll('[data-kit-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button===photo)));
  });
  select.addEventListener('change',()=>showGroup(select.value));
 });
}
setupKitGalleries();
document.addEventListener('shopify:section:load',setupKitGalleries);
